import { useCallback, useEffect, useState } from 'react';
import { listDomains } from 'services/DomainService';
import { listSenders } from 'services/SenderService';
import { DOMAIN_STATUS } from '../domains/constants';

function hostFromEmail(email) {
    if (typeof email !== 'string') {
        return null;
    }
    const s = email.trim().toLowerCase();
    const i = s.lastIndexOf('@');
    return i > 0 && i < s.length - 1 ? s.slice(i + 1) : null;
}

function getVerifiedHosts(domains) {
    return domains
        .filter((d) => d?.status === DOMAIN_STATUS.RUNNING && d?.domain)
        .map((d) => String(d.domain).trim().toLowerCase());
}

function settledArray(entry) {
    return entry?.status === 'fulfilled' && Array.isArray(entry.value) ? entry.value : [];
}

function checkDomainVerified(sender, verifiedHosts) {
    const host = hostFromEmail(sender.senderEmail);
    return host != null && verifiedHosts.includes(host);
}

export function useObtainSenders() {
    const [senders, setSenders] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchSenders = useCallback(() => {
        setLoading(true);
        return Promise.allSettled([listSenders(), listDomains()])
            .then(([sendersResult, domainsResult]) => {
                const rawSenders = settledArray(sendersResult);
                const rawDomains = settledArray(domainsResult);
                const verifiedHosts = getVerifiedHosts(rawDomains);

                setSenders(
                    rawSenders.map((sender) => ({
                        ...sender,
                        domainVerified: checkDomainVerified(sender, verifiedHosts),
                    })),
                );
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        void fetchSenders();
    }, [fetchSenders]);

    return { senders, loading, fetchSenders };
}
